import { useMemo } from "react";

import BadgeNext from "ds/components/BadgeNext";
import { RunPolicyReceipt } from "types/generated";
import Tree from "ds/components/Tree";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryPolicy from "components/Run/elements/HistoryEntryPolicy";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";
import { useVisibilityToggle } from "../../hooks/useVisibilityToggle";
import { getPolicyEvaluation } from "./utils";

type TriggerPoliciesEntryProps = {
  list: RunPolicyReceipt[];
  openListByDefault: boolean;
  stackId: string;
  runId: string;
  isModuleRun: boolean;
};

const TriggerPoliciesEntry = ({
  list,
  openListByDefault,
  stackId,
  runId,
  isModuleRun,
}: TriggerPoliciesEntryProps) => {
  const [show, toggle] = useVisibilityToggle(openListByDefault);

  const evaluation = useMemo(() => getPolicyEvaluation(list), [list]);

  const label = (
    <>
      <HistoryEntryLabel>
        <strong>Trigger policies</strong> evaluated to
      </HistoryEntryLabel>
      <BadgeNext
        text={evaluation.label.toUpperCase()}
        variant={evaluation.badgeVariant}
        type="strong"
      />
    </>
  );

  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.TriggerPolicies}
      timestamp={evaluation.timestamp}
      onClick={toggle}
      isOpen={show}
      label={label}
      terminal
    >
      {show && (
        <Tree padding="0 0 0 large">
          {list.map((policy) => (
            <HistoryEntryPolicy
              key={policy.id}
              item={policy}
              runId={runId}
              stackId={stackId}
              isModuleRun={isModuleRun}
            />
          ))}
        </Tree>
      )}
    </HistoryEntryWrapper>
  );
};

export default TriggerPoliciesEntry;
